import React, { useEffect, useState } from 'react';
import { Alert, Card, Col, Modal, Row, Spinner, Table } from 'react-bootstrap';
import { useContextInfo } from '../../context/ContextInfo';
import { fetchConToken } from '../../api/fetch';

const ModPingEq = ({ show, onClose, ip, mknodo }) => {
    const [loading, setLoading] = useState(false);
    const [ping, setPing] = useState([]);
    const { setResp } = useContextInfo();

    useEffect(() => {
        if (ip && show) onSubmit();
    }, [ip, show]);

    const onSubmit = async () => {
        if (loading) return;

        setLoading(true);
        const res = await fetchConToken('networks/pingmk', { ip, mknodo: parseInt(mknodo) }, 'POST');
        if (res.ok) {
            setPing(res.data);
        } else {
            setResp(res);
        }
        setLoading(false);
    };

    const onHide = () => {
        setLoading(false);
        setPing('');
        onClose();
    };

    return (
        <Modal show={show} onHide={onHide} size="xl">
            <Modal.Header onHide={onHide} closeButton>
                <h4 className="modal-title">Haciendo ping a {ip}</h4>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col>
                        <Card>
                            <Card.Body>
                                {loading ? (
                                    <div style={{ textAlign: 'center', alignItems: 'center' }}>
                                        <Spinner animation="border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </Spinner>{' '}
                                        <br />
                                        <span>Enviando ping...</span>
                                    </div>
                                ) : ping ? (
                                    <Table striped bordered hover size="sm">
                                        <thead>
                                            <tr>
                                                <th>Secuencia</th>
                                                <th>Host</th>
                                                <th>Tamaño</th>
                                                <th>TTL</th>
                                                <th>Tiempo</th>
                                                <th>Enviado</th>
                                                <th>Recibido</th>
                                                <th>Pérdida de Paquetes</th>
                                                <th>RTT Mínimo</th>
                                                <th>RTT Promedio</th>
                                                <th>RTT Máximo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ping.map((ping, index) => (
                                                <tr key={index}>
                                                    <td>{ping.seq}</td>
                                                    <td>{ping.host}</td>
                                                    <td>{ping.size}</td>
                                                    <td>{ping.ttl}</td>
                                                    <td>{ping.time}</td>
                                                    <td>{ping.sent}</td>
                                                    <td>{ping.received}</td>
                                                    <td>{ping['packet-loss']}</td>
                                                    <td>{ping['min-rtt']}</td>
                                                    <td>{ping['avg-rtt']}</td>
                                                    <td>{ping['max-rtt']}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                ) : (
                                    <Alert variant="danger">Error al hacer ping al equipo</Alert>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};

export default ModPingEq;
